// Add your custom JS here.
import Vimeo from '@vimeo/player';

import Swiper, { Mousewheel, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Mousewheel]);

// import { gsap } from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin";
//
// gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


const players = [];

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.modal').forEach((element) => {
    const player = new Vimeo(element.querySelector('iframe'));
    players.push(player);

    element.addEventListener('shown.bs.modal', () => {
      players.forEach((p) => p.pause());
      player.play();
    });

    element.addEventListener('hide.bs.modal', () => {
      player.pause();
    });
  });
});

window.players = players;

// // REVEAL ELEMENTS EFFECT
// gsap.fromTo(".work", {opacity: 0,y: 40,}, {opacity: 1,y: 0, duration: 1});
// gsap.fromTo(".about", {opacity: 0,y: 40,}, {opacity: 1,y: 0, duration: 1});

document.addEventListener('DOMContentLoaded', () => {
  const players = [];
  document.querySelectorAll('.homepage-swiper iframe').forEach((element) => {
    players.push(new Vimeo(element));
  });

  const swiper = new Swiper(".homepage-swiper", {
    direction: "vertical",
    slidesPerView: 1,
    spaceBetween: 30,
    mousewheel: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  swiper.on('slideChange', () => {
    players.forEach((p) => p.pause());
    players[swiper.activeIndex].play();
  });
});
